import { useContext } from 'react';
import { ApiDataContext } from '../data/api/ApiDataContext';
import { BrokerHubDataContext } from '../data/broker-hub/BrokerHubDataContext';
import { DailyPricingDataContext } from '../data/physical-markets/DailyPricingsDataContext';
import { ManagementDataContext } from '../data/management/ManagementDataContext';
import { RiskManagementDataContext } from 'src/data/risk-management/RiskManagementDataContext';

// ----------------------------------------------------------------------
export const useApiData = () => {
  const context = useContext(ApiDataContext);
  if (!context) throw new Error('ApiDataContext data context must be use inside AuthProvider');

  return context;
}

export const useDailyPricingData = () => {
  const context = useContext(DailyPricingDataContext);
  if (!context) throw new Error('DaililyPricing data context must be use inside AuthProvider');

  return context;
};

export const useBrokerHubData = () => {
  const context = useContext(BrokerHubDataContext);
  if (!context) throw new Error('BrokerHub data context must be use inside AuthProvider');

  return context;
};

export const useManagementData = () => {
  const context = useContext(ManagementDataContext);
  if (!context) throw new Error('Management data context must be use inside AuthProvider');

  return context;
} 

export const useRiskManagementData = () => {
  const context = useContext(RiskManagementDataContext);
  if (!context) throw new Error('Risk Management data context must be use inside AuthProvider');

  return context;
}
